<template>
  <div class="layout-image-selector-wrapper">

    <div v-if="isVisibleCancelButton" class="cancel-button" @click="deleteImageFile">
      <div class="icon">
        <svg fill="#ffffff" version="1.1" xmlns="http://www.w3.org/2000/svg"
             x="0px" y="0px" viewBox="0 0 96 96"
             enable-background="new 0 0 96 96" xml:space="preserve">

          <polygon points="96,14 82,0 48,34 14,0
                   0,14 34,48 0,82 14,96 48,62 82,96 96,82 62,48">
          </polygon>

        </svg>
      </div>
    </div>

    <label class="layout-image-selector" :class="{ select: loadingState }" :for="index">

      <div class="overlay">
        <p>클릭 후 이미지 변경</p>
      </div>

      <div v-if="!loadingState"
           :style="{ backgroundImage: `url(${ imageSource === null ? resources.imageIcon : imageSource})` }"
           class="background-image"></div>

      <div v-else class="lds-facebook">
        <div></div><div></div><div></div>
      </div>

      <div v-if="isVisibleInfoViewer" class="image-info">
        <div class="text-wrapper">
          <p class="title">{{ infoViewer.name }}</p>
        </div>
        <div class="text-wrapper">
          <span>크기 : </span>
          <p>{{ infoViewer.size }}MB</p>
        </div>
        <div class="text-wrapper">
          <span>타입 : </span>
          <p>{{ infoViewer.type }}</p>
        </div>
      </div>

    </label>

    <input @change="addImageFile" :id="index" :name="index" type="file" accept="image/*">

  </div>
</template>

<script>
import AddImageIcon from '@/assets/icons/add-image-icon.svg';

export default {
  name: 'LayoutImageSelector',

  props: {
    index: String,
    value: [String, Object, File],
    limitSize: {
      type: Number,
      default: 4194304,
    },

    onImageOutOfSize: {
      type: Function,
      default: () => {},
    },

    onLoadingStart: {
      type: Function,
      default: () => {},
    },

    onLoadingEnd: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    isVisibleInfoViewer() {
      return this.infoViewer !== null;
    },

    isVisibleCancelButton() {
      return this.choiceImage !== null;
    },
  },

  methods: {
    addImageFile(e) {
      if (e.target.files.length < 1) {
        alert('이미지가 선택되지 않았습니다.');
        return;
      }

      const file = e.target.files[0];
      const render = new FileReader();

      if (file.size > this.limitSize) {
        this.onImageOutOfSize();
        return;
      }

      this.onLoadingStart();
      this.loadingState = true;

      render.onload = (event) => {
        this.imageSource = event.target.result;
        this.choiceImage = file;

        this.infoViewer = {
          size: ((file.size / 1024) / 1024).toFixed(1),
          name: file.name,
          type: file.type,
        };

        this.onLoadingEnd();
        this.loadingState = false;
        this.$emit('input', this.choiceImage);
      };

      render.readAsDataURL(file);
    },

    deleteImageFile() {
      this.choiceImage = null;
      this.imageSource = null;
      this.infoViewer = null;

      this.$emit('input', null);
    },
  },

  data() {
    return {
      choiceImage: this.value || null,
      imageSource: this.value || null,

      loadingState: false,

      resources: {
        imageIcon: AddImageIcon,
      },

      infoViewer: null,
    };
  },
};
</script>

<style lang="scss" scoped>

.layout-image-selector-wrapper {
  position: relative;

  margin-top: 15px;
  margin-bottom: 15px;

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  .cancel-button {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    position: absolute;
    z-index: 101;

    top: -10px;
    right: -10px;

    width: 25px;
    height: 25px;
    cursor: pointer;

    border-radius: 15px;
    background-color: rgb(230, 111, 111);

    .icon {
      position: relative;
      display: block;
      margin: auto;
      text-align: center;

      width: 12px;
      height: 12px;

      top: -3px;
    }
  }

  .layout-image-selector {
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    width: 200px;
    height: 200px;

    border-radius: 5px;
    border: rgba(102, 102, 102, 0.2) 1px solid;

    background-color: rgb(255, 255, 255); //rgba(102, 102, 102, 0.2);
    transition: background-color 0.2s ease-in-out;

    cursor: pointer;

    .background-image {
      width: 150px;
      height: 150px;

      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }

    .image-box {
      position: relative;
      width: auto;
      height: auto;
      margin-bottom: 10px;
      margin-top: 10px;

      .prevImage {
        position: relative;

        .image {
          position: absolute;
          top: 0;
          left: 0;

          border-radius: 5px;
          margin-right: 10px;

          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }

    .file-box {
      width: auto;
      height: auto;
      margin-bottom: 10px;
      margin-top: 10px;

      label {
        padding: 15px 10px;
        color: rgb(30, 30, 30);
        background-color: rgb(255, 255, 255);
        cursor: pointer;
        border: 1px solid rgb(230, 230, 230);
        border-radius: .25em;
      }
    }

    .file-box input[type="file"] {
      /* 파일 필드 숨기기 */
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }

    .file-box label:hover {
      border: 1px solid rgb(0, 181, 173);
      color: rgb(0, 181, 173);
    }

    .error {
      color: rgb(159, 85, 80);
      background: rgb(217, 162, 181);
      border: rgb(240, 162, 181) 1px solid;
    }

    .lds-facebook {
      z-index: 1001;

      display: inline-block;
      position: relative;
      width: 64px;
      height: 64px;

      div {
        display: inline-block;
        position: absolute;
        left: 6px;
        width: 13px;
        background-color: #fff;
        animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
      }

      div:nth-child(1) {
        left: 6px;
        animation-delay: -0.24s;
      }

      div:nth-child(2) {
        left: 26px;
        animation-delay: -0.12s;
      }

      div:nth-child(3) {
        left: 45px;
        animation-delay: 0;
      }
    }

    @keyframes lds-facebook {
      0% {
        top: 6px;
        height: 51px;
      }
      50%, 100% {
        top: 19px;
        height: 26px;
      }
    }

    .image-info {
      position: absolute;
      top: 0;
      left: 220px;

      width: auto;
      height: auto;

      padding: 10px;

      /*background-color: rgba(0, 0, 0, 0.2);*/

      transition: opacity 0.2s ease-in-out;
      opacity: 0;

      background-color: rgb(255, 255, 255);
      border-radius: 5px;
      border: rgba(0, 0, 0, 0.3) 1px solid;

      .text-wrapper {
        position: relative;
        margin-bottom: 15px;

        span, p {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6)
        }

        .title {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.9)
        }
      }
    }

    .overlay {
      display: none;
    }
  }

  .layout-image-selector:hover {
    .overlay {
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;

      position: absolute;
      z-index: 100;

      top: 0;
      left: 0;

      width: 100%;
      height: 100%;
      background-color: rgba(102, 102, 102, 0.5);
      cursor: pointer;
      border-radius: 5px;

      p {
        font-size: 22px;
        color: rgba(255, 255, 255, 1)
      }
    }

    .image-info {
      opacity: 1;
    }
  }

  .select {
    background-color: rgba(102, 102, 102, 0.2) !important;
    cursor: progress !important;
  }

}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutImageSelector.vue